export default __webpack_public_path__ + "static/media/039-warehouse.70274bda.svg";